import { Contribution } from './Models';

export enum Type {
  SET_CONTRIBUTIONS = 'DASHBOARD/CONTRIBUTION_VOLUME/SET_CONTRIBUTIONS',
  RESET = 'DASHBOARD/CONTRIBUTION_VOLUME/RESET',
}

interface Action<T> {
  type: T;
}

export interface SetContributions extends Action<Type.SET_CONTRIBUTIONS> {
  contributions?: Contribution[];
}

export interface Reset extends Action<Type.RESET> {}

type Actions = SetContributions | Reset;

export interface State {
  isLoading: boolean;
  contributions?: Contribution[];
}

export const initialState: State = {
  isLoading: true,
  contributions: undefined,
};

export default (state = initialState, action: Actions): State => {
  switch (action.type) {
    case Type.SET_CONTRIBUTIONS:
      return {
        ...state,
        contributions: action.contributions,
        isLoading: false,
      };
    case Type.RESET:
      return { ...initialState };
    default:
      return state;
  }
};

export const actions = {
  setContributions: (contributions?: Contribution[]): SetContributions => ({
    type: Type.SET_CONTRIBUTIONS,
    contributions,
  }),
  reset: (): Reset => ({
    type: Type.RESET,
  }),
};
